import { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import "core-js/stable/atob";


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      const response = await axios.post('/', { refreshToken });
      localStorage.setItem('token', response.data.accessToken);
      return response.data.accessToken;
    } catch (error) {
      setIsAuthenticated(false);
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      setUser({ id: decodedToken.id, role: decodedToken.role });
      if (decodedToken.exp < currentTime) {
        refreshAccessToken();
      }
      setIsAuthenticated(true);
    }
    setLoading(false);

    // Set up token refresh interval
    const intervalId = setInterval(() => {
      const token = localStorage.getItem('token');
      if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp - currentTime < 300) { // Refresh 5 mins before expiry
          refreshAccessToken();
        }
      }
    }, 60000); // Check every minute

    return () => clearInterval(intervalId);
  }, []);

  return (
    <AuthContext.Provider 
    value={{ 
      isAuthenticated, 
      setIsAuthenticated,
      user,
      setUser,
      loading,
      refreshAccessToken 
      }}>
      {children}
    </AuthContext.Provider>
  );
};


